type FooterTopLinkItem = {
  content: string;
  path: string;
  hideOnRuBlockedFlag?: true;
};

export type FooterTopLinks = {
  header: string;
  items: FooterTopLinkItem[];
}[];

export const footerTopLinks: FooterTopLinks = [
  {
    header: "service",
    items: [
      {
        content: "Correspondence",
        // path: "/page/A_CORRESPONDENCE",
        path: "/page?A_CORRESPONDENCE",
      },
      {
        content: "Flowers & Presents",
        // path: "/page/B_GIFTS",
        path: "/page?B_GIFTS",
      },
      {
        content: "Phone translation",
        // path: "/page/C_PHONE",
        path: "/page?C_PHONE",
      },
      {
        content: "Live Chat",
        // path: "/page/D_CHAT",
        path: "/page?D_CHAT",
      },
      {
        content: "Video chat",
        // path: "/page/F_VIDEOCHAT",
        path: "/page?F_VIDEOCHAT",
      },
      {
        content: "FAQ",
        // path: "/page/FAQ",
        path: "/page?FAQ",
      },
    ],
  },
  {
    header: "About Us",
    items: [
      {
        content: "About Us",
        // path: "/page/ABOUT",
        path: "/page?ABOUT",
      },
      {
        content: "Golden and IMBRA",
        // path: "/page/IMBRA",
        path: "/page?IMBRA",
      },
      {
        content: "Anti-Scam Policy",
        // path: "/page/ANTISCAM",
        path: "/page?ANTISCAM",
      },
      {
        content: "Customer service",
        // path: "/page/CUSTOMERSERVICE",
        path: "/page?CUSTOMERSERVICE",
      },
      {
        content: "Contact Us",
        // path: "/page/CONTACT",
        path: "/page?CONTACT",
      },
      {
        content: "Terms and conditions",
        // path: "/page/TERMS",
        path: "/page?TERMS",
      },
      {
        content: "Content Moderation Policy",
        // path: "/page/TERMS",
        path: "/page?CONTENT_MODERATION",
      },
      {
        content: "Privacy Policy",
        // path: "/page/PRIVACY",
        path: "/page?PRIVACY",
      },
      {
        content: "Refund policy",
        // path: "/page/REFUNDPOLICY",
        path: "/page?REFUNDPOLICY",
      },
      {
        content: "Reviews",
        path: "/reviews.html",
      },
    ],
  },
  {
    header: "Search Ladies Profiles",
    items: [
      {
        content: "Advanced Search",
        path: "/search",
      },
      {
        content: "Online Ladies",
        path: "/search?online=true",
      },
      {
        content: "Top 1000 Ladies",
        path: "/search?topLadies=true",
      },
      {
        content: "Mail Order Brides",
        path: "/mail-order-brides.html",
      },
      {
        content: "Hot Sexy Russian Girls",
        path: "/hot-sexy-russian-girls.html",
        hideOnRuBlockedFlag: true,
      },
      {
        content: "Mail Order Russian Brides",
        path: "/mail-order-russian-brides.html",
        hideOnRuBlockedFlag: true,
      },
      {
        content: "Dating overseas",
        path: "/dating-overseas.html",
      },
      {
        content: "Interracial dating",
        path: "/interracial-dating.html",
      },
    ],
  },
  {
    header: "Partners",
    items: [
      {
        content: "Become partner",
        path: "/agency",
      },
      {
        content: "Affiliate program",
        path: "/affiliate",
      },
    ],
  },
];

export const goldenMeetsFooterTopLinks: FooterTopLinks = [
  {
    header: "Service",
    items: [
      {
        content: "Live Chat",
        path: "/t_chat.html",
      },
      {
        content: "Video chat",
        path: "/t_vchat.html",
      },
    ],
  },
  {
    header: "About Us",
    items: [
      {
        content: "Contact Us",
        path: "/t_contact.html",
      },

      {
        content: "About Us",
        path: "/t_about.html",
      },

      {
        content: "Customer service",
        path: "/t_customer.html",
      },
    ],
  },
  {
    header: "LEGAL",
    items: [
      {
        content: "Terms and conditions",
        path: "/t_terms.html",
      },
      {
        content: "Anti-Scam Policy",
        path: "/t_antiscam.html",
      },
      {
        content: "Privacy Policy",
        path: "/t_privacy.html",
      },
      {
        content: "Refund policy",
        path: "/t_refund.html",
      },
    ],
  },
];

export const footerDataBrideByProfession = {
  header: "Find Bride by Profession",
  items: [
    [
      {
        content: "Doctor",
        path: "doctor-dating-site.html",
      },
      {
        content: "Fitness",
        path: "fitness-dating-site.html",
      },
      {
        content: "Teacher",
        path: "teacher-dating-site.html",
      },
    ],
    [
      {
        content: "Lawyer",
        path: "lawyer-dating-site.html",
      },
      {
        content: "Model",
        path: "model-dating-site.html",
      },
      {
        content: "Entrepreneur",
        path: "entrepreneur-dating-site.html",
      },
    ],
  ],
} as const;
